import { ChatMentionSuggestion, PromptChatAdapter } from '../../../components/Chat/PromptChatAdapter';
import { designerChatAgentIds, designerChatScopes, useDesignerChatAdapter } from '../../../components/Chat/useDesignerChatAdapter';
import { Bundle } from '../Models/Bundle';

export type UserInterfaceChatArtifactContext = {
	viewId?: string;
	sharedComponentId?: string;
	resourceId?: string;
	area?: 'App-Theme' | 'App-Settings';
	themeName?: string;
	componentId?: string;
	componentPath?: string;
	reactComponentId?: string;
	reactComponentName?: string;
	reactComponentHostState?: 'Unassigned' | 'Bound';
	reactSourceFileId?: string;
	reactSourceFilePath?: string;
};

export function useUserInterfaceChatAdapter(
	bundle: Bundle | null,
	changeSetId?: string | null,
	artifactContext?: UserInterfaceChatArtifactContext,
): PromptChatAdapter {
	return useDesignerChatAdapter({
		scopeName: designerChatScopes.userInterface,
		agentId: designerChatAgentIds.userInterface,
		targetId: bundle?.Id,
		isAvailable: !!bundle && !!changeSetId?.trim(),
		missingTargetMessage: bundle ? 'No change set selected.' : 'No bundle selected.',
		messageAttributes: () => ({
			ChangeSetId: changeSetId?.trim(),
			ViewId: artifactContext?.viewId,
			SharedComponentId: artifactContext?.sharedComponentId,
			ResourceId: artifactContext?.resourceId,
			Area: artifactContext?.area,
			ThemeName: artifactContext?.themeName,
			ComponentId: artifactContext?.componentId,
			ComponentPath: artifactContext?.componentPath,
			ReactComponentId: artifactContext?.reactComponentId,
			ReactComponentName: artifactContext?.reactComponentName,
			ReactComponentHostState: artifactContext?.reactComponentHostState,
			FileId: artifactContext?.reactSourceFileId,
			ReactSourceFileId: artifactContext?.reactSourceFileId,
			ReactSourceFilePath: artifactContext?.reactSourceFilePath,
		}),
		searchMentions: async (query: string): Promise<ChatMentionSuggestion[]> => {
			if (!bundle) return [];
			const q = query.toLowerCase();
			const suggestions: ChatMentionSuggestion[] = [];

			bundle.Views.filter((v) => v.Title?.toLowerCase().includes(q)).forEach((v) => {
				suggestions.push({ name: v.Title, type: 'View' });
			});

			bundle.SharedComponents.filter((c) => c.Name?.toLowerCase().includes(q)).forEach((c) => {
				suggestions.push({ name: c.Name, type: 'SharedComponent' });
			});

			bundle.EmbeddedResources.filter((r) => r.Name?.toLowerCase().includes(q)).forEach((r) => {
				suggestions.push({ name: r.Name, type: 'EmbeddedResource' });
			});

			return suggestions;
		},
	});
}
